export default [
  {
    path: '/scholarship',
    name: 'scholarship',
    component: () => import('@/views/scholarship/Menu.vue'),
    meta: { IsParent: true },
  },
];
